// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"c53b78d7","278":"1bec3c03","396":"e8a98d42","532":"75208a92","889":"24aef7fa","956":"9c54c345"}[chunkId] + ".chunk.css";
};